export const REQUEST_TOKEN = 'REQUEST_TOKEN';
export const CONFIRM_TOKEN = 'CONFIRM_TOKEN';
